import React from "react";

/**
 * Business Partner Status Badge
 * ACTIVE   → Green
 * INACTIVE → Red
 */

export default function BPStatusBadge({ status }) {
  const isActive = status === "ACTIVE";

  const style = {
    display: "inline-block",
    padding: "2px 10px",
    borderRadius: 12,
    fontSize: 12,
    fontWeight: 600,
    backgroundColor: isActive ? "#dcfce7" : "#fee2e2",
    color: isActive ? "#166534" : "#991b1b",
    border: `1px solid ${
      isActive ? "#86efac" : "#fca5a5"
    }`,
  };

  return (
    <span style={style}>
      {isActive ? "Active" : "Inactive"}
    </span>
  );
}
